import { ExpertChipExpression } from '@nrwl/query-emitter';
import { IChip } from '../types';

const operators = {
  '=': {
    symbol: '=',
    m_value: 'IN'
  },
  '!=': {
    symbol: '≠',
    m_value: 'NOT IN'
  }
};

export class Chip extends ExpertChipExpression implements IChip {
  name: string;
  readonly = false;
  constructor(keyword: string, operand: string, operands: string[], name?: string) {
    super(keyword, operand || '=', operands);
    this.name = name || keyword;
    this.operator = this.normalizeOperator(this.operator);
  }

  /**
   *  chip based input prefers to show just 2 operators: == and !=
   * While outside sources may have more than that (eg, IN, NOT IN, etc)
   * attempt normalizing operator to == and != if possible. If not possible to normalize,
   * we should give a reasonable error explaining the cause.
   */
  normalizeOperator(input: string): string {
    switch (input.toUpperCase()) {
      case '=':
      case '!=':
      case '~':
      case '!~':
        return input;
      case 'IN':
        return '=';
      case 'NOT IN':
        return '!=';
      default:
        throw Error(
          `The operators supported by Chip expression are: "=", "!=", "IN" and "NOT IN". "${input}" is not supported.`
        );
    }
  }

  get operandsExpression() {
    return this.operands.join(',');
  }

  get operatorSymbol() {
    return operators[this.operator].symbol;
  }

  changeOperator(operator: string) {
    this.operator = operator;
  }

  toString() {
    return `${this.keyword} ${this.operator} "${this.operandsExpression}"`;
  }
}
